/**
 * <summary>
 * "StoreDetails" component shows the store details form with breadcrumbs and language slider.
 * </summary>
 */

import { FormattedMessage } from "react-intl";
import LanguageSlider from "../../../shared-components/language-slider/language-slider";
import AddStoreDetails from "./components/add-edit-store-details";
const StoreDetails = (props: any) => {
  return (
    <>
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="store_details" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="store_management" />
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <FormattedMessage id="store_details" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-6">
            <ul className="add-list">
              <li>
                <LanguageSlider />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <AddStoreDetails />
    </>
  );
};

export default StoreDetails;
